
/**
 * @ngdoc Controller
 * @name InstallationController
 */
(function () {
    'use strict';

    angular.module('vrm.core')
        .controller('InstallationController', InstallationController);

    /**
     * @constructor
     * @ngInject
     */
    function InstallationController($log, $rootScope, $scope, $stateParams, InstallationsService, $timeout, $document, vrmNotificationsService, vrmNotificationType, $filter, locale, $state) {
        $log.info('InstallationController');

        var title = null;
        $scope.$watchCollection('installations', function () {
            InstallationsService.getInstallation($stateParams.id).then(function (installation) {
                if (installation) {
                    $scope.installation = installation;
                    InstallationsService.setRealtimeInstallation(installation);
                    $rootScope.viewTitle = installation.name;
                    title = $rootScope.viewTitle;


                    const invalidVRMAuthTokenUsedInLogRequest = installation.invalidVRMAuthTokenUsedInLogRequest;
                    const invalidMQTTpasswordChangedAt = installation.invalidMqttPasswordSentAt;

                    const notAuthVRM = invalidVRMAuthTokenUsedInLogRequest > 0
                    const notAuthMQTT = invalidMQTTpasswordChangedAt > 0
                    const bothInvalid = invalidMQTTpasswordChangedAt > 0 && invalidVRMAuthTokenUsedInLogRequest > 0

                    if(notAuthVRM || notAuthMQTT) {
                        installation.isUnauthenticatedDeviceDataVRM = (notAuthVRM)  && installation.view_permissions.update_settings
                        installation.isUnauthenticatedDeviceDataMQTT =  (!notAuthVRM && notAuthMQTT) && installation.view_permissions.update_settings

                        if(bothInvalid){
                            const tokenval = invalidVRMAuthTokenUsedInLogRequest;
                            locale.ready('general').then(function () {
                                $scope.installation.unauthenticated_device_data = locale.getString('general.confirm_reset_description_link', {
                                    ago: $filter('amTimeAgo')(tokenval * 1000),
                                    url: $state.href('base.installation.settings.general', {id: installation.id}) + '#resetAuthToken'
                                });
                            });
                        }
                        if(!notAuthVRM && notAuthMQTT){
                            const tokenval = invalidMQTTpasswordChangedAt;
                            locale.ready('general').then(function () {
                                $scope.installation.unauthenticated_device_data = locale.getString('general.confirm_mqtt_reset_description_link', {
                                    ago: $filter('amTimeAgo')(tokenval * 1000),
                                    url: $state.href('base.installation.settings.general', {id: installation.id}) + '#resetAuthToken'
                                });
                            });
                        }
                        if(notAuthVRM && !notAuthMQTT){
                            const tokenval = invalidVRMAuthTokenUsedInLogRequest;
                            locale.ready('general').then(function () {
                                $scope.installation.unauthenticated_device_data = locale.getString('general.confirm_reset_description_link', {
                                    ago: $filter('amTimeAgo')(tokenval * 1000),
                                    url: $state.href('base.installation.settings.general', {id: installation.id}) + '#resetAuthToken'
                                });
                            });
                        }
                    }

                } else {
                    $state.go("base.installation-overview")
                }
            });
        });

        $scope.outdatedTimestamp = function (timestamp){
            // timestamp set to today - 3 days (to set warnings for serial numbers of devices that might have failed but are still reported in db)
            var setWarningThreshold = new Date();
            setWarningThreshold.setDate(setWarningThreshold.getDate() - 3);
            var timestampObj = new Date(timestamp *1000);
            return timestampObj < setWarningThreshold.getTime();
        }

        // Screensaver
        $scope.screensaver = false;
        var screensaverTimeout = null;
        var screensaverTime = 0;
        var lastMouseX = null;
        var lastMouseY = null;
        var lastPressedKey = null;

        // Check for profile updates
        $scope.$watch('user.screensaverTimeout', function (timeout) {
            if (!timeout || parseInt(timeout) <= 0) return;
            screensaverTime = parseInt(timeout);
            scheduleScreensaverTimeout();
        });

        var handleScreenSaverEvent = function (e) {
            // Chrome periodically fires mousemove events automatically, thus we
            // first have to check if the mouse has actually moved on mousemove.
            if (e.type == 'mousemove') {
                if (e.pageX == lastMouseX && e.pageY == lastMouseY) {
                    return;
                }
                lastMouseX = e.pageX;
                lastMouseY = e.pageY;
            }
            // Is the body the active element? (aka, ignore typing double S in a input field)
            else if (e.target.nodeName.toLowerCase() == "body" && e.type == "keyup") {
                // Check for modifier keys
                if (e.shiftKey || e.ctrlKey || e.altKey || e.metaKey) {
                    // If any modifier key is pressed, don't activate the screensaver
                    return;
                }
                // Was the previous key a S as well?
                if (lastPressedKey == 83 && e.which == 83) {
                    e.stopPropagation();
                    lastPressedKey = null;
                    if (!$scope.screensaver) {
                        $scope.screensaver = true;
                        $log.info('Enabling screensaver');
                        $scope.$evalAsync();
                    }
                    return;
                } else {
                    lastPressedKey = e.which;
                    return;
                }
            }
            scheduleScreensaverTimeout();
        };
        $document.on('scroll keydown keyup mousemove mousedown', handleScreenSaverEvent);

        var scheduleScreensaverTimeout = function () {
            $timeout.cancel(screensaverTimeout);
            if ($scope.screensaver) {
                $log.info('Disabling screensaver');
                InstallationsService.setRealtimeInstallation($scope.installation);
                $scope.screensaver = false;
                $scope.$evalAsync();
            }

            if (!screensaverTime > 0) return;
            screensaverTimeout = $timeout(function () {
                $log.info('Enabling screensaver');
                InstallationsService.setRealtimeInstallation(null);
                $scope.screensaver = true;
                $scope.$evalAsync();
            }, screensaverTime, false);
        };

        $scope.$on('$destroy', function () {
            // Clean up screensaver event handlers
            $timeout.cancel(screensaverTimeout);
            $document.off('scroll keydown keyup mousemove mousedown', handleScreenSaverEvent);

            // Unsubscribe mqtt
            InstallationsService.setRealtimeInstallation(null);
            if (title === $rootScope.viewTitle) {
                $rootScope.viewTitle = null;
            }
            // cleanup error message

            $scope.installation.unauthenticated_device_data = null;
        });
    }

})();
